import { ButtonType, ButtonVariant } from "@/componentsDS/Button/Button.type";
import { useEffect, useState } from "react";
import Button from "@/componentsDS/Button/Button";
import Modal from "@/dsComponents/Modal";
import Input from "@/componentsDS/Input/index";
import { ModalBody, ModalFooter, ModalFooterLeft, ModalFooterRight, ModalHeader, ModalTitle } from "@dextech-ai/dex-design-system";
import { InfoOutlined } from "@dextech-ai/dex-design-system/icons";
import PropTypes from "prop-types";

export const EditModelTermModal = ({
	isModalVisible,
	hideModal,
	onEditHandler,
	name,
}) => {
	const [termName, setTermName] = useState("");
	const [isValid, setIsValid] = useState(false);

	const onTermClauseNameChange = (value) => {
		const trimmedValue = value.trim();
		const isValid = Boolean(trimmedValue.length > 0) && trimmedValue !== name;
		setTermName(trimmedValue);
		setIsValid(isValid);
	};

	useEffect(() => {
		if (isModalVisible) {
			setTermName(name)
			setIsValid(false);
		}
	}, [isModalVisible])

	return (
		<Modal visible={isModalVisible} close={hideModal}>
			<ModalHeader icon={<InfoOutlined data-ds-color="primary-dark" />}>
				<ModalTitle>Edit Template Name</ModalTitle>
			</ModalHeader>
			<ModalBody>
				<Input
					id="term-name"
					name="term-name"
					label="Template Name"
					required
					onChange={onTermClauseNameChange}
					value={name}
					fullWidth
				/>
			</ModalBody>
			<ModalFooter>
				<ModalFooterLeft>
					<Button
						onClick={() => {
							hideModal();
						}}
						text="Cancel"
						type={ButtonType.GHOST}
						variant={ButtonVariant.STANDARD}
						className="account-settings__modal_term-action"
					/>
				</ModalFooterLeft>
				<ModalFooterRight>
					<Button
						disabled={!isValid}
						onClick={() => onEditHandler(termName)}
						text="Done"
						type={ButtonType.SOLID}
						variant={ButtonVariant.STANDARD}
						className="account-settings__modal_term-action"
					/>
				</ModalFooterRight>
			</ModalFooter>
		</Modal>
	);
};

EditModelTermModal.propTypes = {
	isModalVisible: PropTypes.bool.isRequired,
	hideModal: PropTypes.func.isRequired,
	onEditHandler: PropTypes.func.isRequired,
	name: PropTypes.string,
};
